import styled from '@xstyled/styled-components';

export const LeftBorder = styled.div<{ highlightColor: string }>`
  background-color: ${p => p.highlightColor};
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
  margin-right: 31px;
  height: 104px;
  width: 323px;
  position: relative;
  > .LeftShape {
    box-shadow: -6px 6px 6px grey;
    padding-left: 3px;
  }

  &:after {
    content: '';
    z-index: 1;
    position: absolute;
    right: -32px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 32px solid ${p => p.highlightColor};
    border-top: 52px solid transparent;
    border-bottom: 52px solid transparent;
  }

  .dragMe {
    display: none;
    z-index: 3;
    position: inherit;
    text-align: center;
    font-size: 12px;
    padding-top: 5px;
  }
  &:hover {
    .dragMe {
      display: block;
    }
  }
`;
